<div class="mx-5" class="app-selector-container mt-2" [ngClass]="{'disableTableRow': disableDropDown}" appCounting>
  <!-- <div class="app-icon" *ngIf="selectedApp && selectedApp.app">
    <app-platform-icon class="d-inline-block align-middle menu-icon" style="color:#fff;" [platform]="selectedApp.app.os"
      [iconSize]="'20px'" (click)="toggleDropdown()"></app-platform-icon>
  </div> -->

  <div class="fake-dd cursor-pointer" [ngClass]="{'open' : isOpen}">

    <div class="app-name d-inline-block" (click)="toggleDropdown()" *ngIf="!selectedApp || !selectedApp.app" matRipple
      matRippleColor="'white'">
      <span class="d-inline-block ml-2 text-truncate name align-middle">Select App</span>
      <span class="align-middle float-right">
        <i class="material-icons keyboard_arrow_down">keyboard_arrow_down</i>
      </span>
    </div>

    <div class="app-name d-inline-block" (click)="toggleDropdown()" *ngIf="selectedApp.app && selectedApp.app.id"
      matRipple matRippleColor="'white'">
      <span class="d-inline-block ml-2 text-truncate name align-middle">
        {{selectedApp.app.name}}
      </span>
      <span class="align-middle float-right">
        <i class="material-icons arrow_drop_down">arrow_drop_down</i>
      </span>
    </div>
    <div class="fake-panel">
      <div class="search-container my-2" *ngIf="appMap[currentEnvironment] && appMap[currentEnvironment].length > 10">
        <span class="d-inline-block align-middle">
          <i class="material-icons">search</i>
        </span>
        <span class="d-inline-block align-middle w-80">
          <input type="text" name="searchText" placeholder="Search ..." class="w-100" [(ngModel)]="searchText">
        </span>
        <span class="align-middle float-right" (click)="toggleDropdown()">
          <i class="material-icons arrow_drop_up">arrow_drop_up</i>
        </span>
      </div>
      <ul class="mb-2">

        <!-- SELECTED APP -->
        <li class="active" *ngIf="showSelectedApp()" matRipple>
          <app-platform-icon class="ml-1 mr-2" [platform]="selectedApp.app.os"></app-platform-icon>
          <span class="text-truncate" title="{{selectedApp.app.name}}">{{selectedApp.app.name}}</span>
          <span class="float-right pr-2 green-tick">
            <i class="material-icons fg-green">done</i>
          </span>
        </li>

        <div class="divider" *ngIf="showSelectedApp()">&nbsp;</div>

        <li class="sub-heading" *ngIf="shouldShowThisSection() || shouldShow">PAID APPS</li>
        <li *ngFor="let app of getAppListByAppState('production') | filter: {name:searchText}; index as i"
          (click)="selectApp(app, i, 'production'); $event.stopPropagation();" matRipple>
          <app-platform-icon class="ml-1 mr-2" [platform]="app.os"></app-platform-icon>
          <span class="text-truncate" title="{{app.name}}">{{app.name}}</span>
        </li>

        <div class="divider">&nbsp;</div>

        <ng-container *ngIf="shouldShowThisSection() || shouldShow">
          <li class="sub-heading">FREE APPS</li>
          <li *ngFor="let app of getAppListByAppState('sandbox') | filter: {name:searchText}; index as i"
            (click)="selectApp(app, i, 'stage'); $event.stopPropagation();" matRipple>
            <app-platform-icon class="ml-1 mr-2" [platform]="app.os"></app-platform-icon>
            <span class="text-truncate" title="{{app.name}}">{{app.name}}</span>
          </li>
          <div class="divider">&nbsp;</div>
        </ng-container>
        <a class="text-decoration-none" (click)="openCreateAppForm()">
          <div class="create-app-link" mat-button> + CREATE NEW</div>
        </a>
      </ul>
    </div>
  </div>
</div>
